import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home128",
  "use": "icon-home128-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-home128\"><path d=\"M63.3 959.2v-63.1h897v63.1h-897z m112.2-96.1V545.7l336.4-336.4 336.4 336.4v317.4H624V622.8H399.7v240.3H175.5z m336.3-723.9L98.4 552.7l-35-42L511.8 62.1 659 209.3V97.2h154.2v266.3l147.2 147.2-35 42-413.6-413.5z\" p-id=\"29984\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol